var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multi-select',{attrs:{"value":_vm.selectedUser,"options":_vm.users,"multiple":false,"close-on-select":true,"track-by":"id","clear-on-select":false,"preserve-search":false,"label":"prenom","custom-label":_vm.textUsername,"show-labels":false,"preselectFirst":_vm.addClujiOption,"allow-empty":false},on:{"input":_vm.updateValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }